var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F0B90B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70219 6.60391L12.0001 4L16.298 6.60391L14.7178 7.56582L12.0001 5.92391L9.28218 7.56582L7.70219 6.60391ZM16.298 9.88783L14.7178 8.92582L12.0001 10.5678L9.28218 8.92582L7.70219 9.88783V11.8117L10.4199 13.4536V16.7376L12.0001 17.6995L13.5802 16.7376V13.4536L16.298 11.8117V9.88783ZM16.298 15.0956V13.1716L14.7178 14.1336V16.0575L16.298 15.0956ZM17.4199 15.7756L14.7021 17.4175V19.3414L19 16.7376V11.5298L17.4199 12.4916V15.7756ZM15.8397 8.24582L17.4199 9.20778V11.1317L19 10.1697V8.24582L17.4199 7.28391L15.8397 8.24582ZM10.4199 18.1141V20.038L12.0001 21L13.5802 20.038V18.1141L12.0001 19.0761L10.4199 18.1141ZM7.70219 15.0956L9.28218 16.0575V14.1336L7.70219 13.1716V15.0956ZM10.4199 8.24582L12.0001 9.20778L13.5802 8.24582L12.0001 7.28391L10.4199 8.24582ZM6.58013 9.20778L8.16031 8.24582L6.58013 7.28391L5 8.24582V10.1697L6.58013 11.1317V9.20778ZM6.58013 12.4916L5 11.5298V16.7376L9.29805 19.3414V17.4175L6.58013 15.7756V12.4916Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBnb);
export default __webpack_public_path__ + "static/media/icon-bnb.58e8cc1c07f613d0d42a05dcbf220876.svg";
export { ForwardRef as ReactComponent };